import { Type } from "class-transformer";
import type { EntityValidationRules } from "../services/validationService";
import Optionable from "utils/optionable";
import Enum from "./enum";
import type SourceType from "./sourceType";
import BankAccount from "./bankAccount";
import { formatBankAccount } from "@edaz/utils/bankAccount";

@Optionable((bankAccountEnum: BankAccountEnum) => ({
  id: bankAccountEnum.id,
  label: formatBankAccount(bankAccountEnum.bankAccount),
}))
export default class BankAccountEnum extends Enum {
  id: string;
  @Type(() => BankAccount)
  bankAccount: BankAccount = new BankAccount();
  currencyCode: string;
  description: string;
  iban: string;
  sourceType: SourceType;
}

export const BankAccountEnumValidationRules: EntityValidationRules<BankAccountEnum> = {
  currencyCode: {
    required: true,
  },
};
